
export const SET_TERMS = (termdata) => {
  return {type: "SET_TERMS", terms: termdata}
}

export const GET_TERMS = {
  type: "GET_TERMS"
}
